(() => {
  if (customElements.get('nidol-product-facts')) return;
  customElements.define('nidol-product-facts', class extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('product-info');
      this.onVariantInput = (event) => {
        if (event.target.name === 'id') this.hidden = !event.target.value;
      };
      this.host?.addEventListener('change', this.onVariantInput);
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.host?.dataset.section) return;
        const source = event.data.html.querySelector('nidol-product-facts');
        if (!source || source.dataset.productId !== this.dataset.productId) return;
        const open = this.querySelector('details[open]')?.dataset.fact;
        this.innerHTML = source.innerHTML;
        this.dataset.variantId = source.dataset.variantId;
        const target = [...this.querySelectorAll('details')].find((item) => item.dataset.fact === open);
        if (target) target.open = true;
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.host?.removeEventListener('change', this.onVariantInput);
    }
  });
})();
